<template>
  <v-container>
    <phone-calls-vue :id="employeeId"></phone-calls-vue>
    <appointment-result-vue :id="employeeId"></appointment-result-vue>
    <week-overall-vue :id="employeeId"></week-overall-vue>
  </v-container>
</template>

<script>
import AppointmentResultVue from './AppointmentResult.vue'
import PhoneCallsVue from './PhoneCalls.vue'
import WeekOverallVue from './WeekOverall.vue'

export default {
  name: 'EmployeeCharts',
  components: {
    PhoneCallsVue,
    AppointmentResultVue,
    WeekOverallVue
  },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  computed: {
    employeeId() {
      return this.id;
    }
  }
}
</script>

<style scoped>
/* Add styles if necessary */
</style>
